export enum WalletConnectionType {
  NONE = "none",
  WALLET = "wallet",
  EMAIL = "email",
}
